define('gumbo-js-client-lib/forms/liveData/InningForm',{
	startIndex: null,
	endIndex: null,
	top: null,
	bottom: null,
	hits: {
		away: null,
		home: null
	}
});
